import { saasRequest } from './api';

const MAX_IMAGE_BYTES = 5 * 1024 * 1024;

function readAsDataUrl(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onerror = () => reject(new Error('Unable to read the selected image.'));
    reader.onload = () => resolve(reader.result);
    reader.readAsDataURL(file);
  });
}

export async function uploadCustomerImage(file) {
  if (!file) throw new Error('Choose an image first.');
  if (!['image/png', 'image/jpeg', 'image/webp'].includes(file.type)) throw new Error('Choose a PNG, JPG, or WEBP image.');
  if (file.size > MAX_IMAGE_BYTES) throw new Error('Customer image must be 5 MB or smaller.');
  const imageData = await readAsDataUrl(file);
  return saasRequest('/tenant/customer-image', { method: 'POST', body: JSON.stringify({ imageData, fileName: file.name }) });
}
